<template>
  <div
    class="d-flex-row space-between"
    v-for="packSelectedOption in selectedOptions"
    :key="packSelectedOption"
  >
    <div class="d-flex-row justify-start flex-8">
      <!-- <img
                :src="packSelectedOption.icon"
                alt="pack_select_option"
                height="20"
                width="20"
            /> -->
      <p class="t-grey font-family-2 regular-l">
        {{ packSelectedOption.title }}
      </p>
    </div>
    <p class="t-white font-family-2 bold-l">
      {{ renderPrice(packSelectedOption) }}
    </p>
  </div>
</template>

<script>
import { calculateCurrency } from "../../../calculate/calculatePrice";
export default {
  data() {
    return {};
  },
  computed: {
    selectedOptions() {
      if (this.checkoutStore.getDetails?.gadgetsAndWeapons?.length > 0) {
        const items = this.getGamePack?.prices?.filter((price) =>
          this.checkoutStore.getDetails?.gadgetsAndWeapons?.includes(price.slab)
        );
        return items;
      }
      return [];
    },
  },

  methods: {
    renderPrice(option) {
      return `${this.getUserCurrencyCode}${parseFloat(
        calculateCurrency(option.price)
      ).toFixed(2)}`;
    },
  },
  setup() {
    const { getGame, getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    const { getUserCurrencyCode } = useUserStore();
    return {
      getGame,
      getGamePack,
      checkoutStore,
      getUserCurrencyCode,
    };
  },
};
</script>
